import createReducer from '../utils/createReducer';
import listingExtendedActions from '../actions/listingExtendedActions';
import listingActions from '../actions/listingActions';
import vtHelpfulnessActions from '../actions/vtHelpfulnessActions';

const initialState = {};

const actionHandlers = {
    [listingExtendedActions.FETCH_URGENCY_MESSAGE_SUCCESS](state, {payload}) {
        const {urgencyMessage} = payload;
        return {
            ...state,
            urgencyMessage
        };
    },
    [listingExtendedActions.FETCH_RANKED_BADGES_SUCCESS](state, {payload}) {
        const {rankedBadges} = payload;
        return {
            ...state,
            rankedBadges
        };
    },
    [listingExtendedActions.FETCH_PRICING_BADGES_SUCCESS](state, {payload}) {
        const {pricingBadges} = payload;
        return {
            ...state,
            pricingBadges
        };
    },
    [listingExtendedActions.FETCH_SUPERLATIVE_BADGES_SUCCESS](state, {payload}) {
        const {superlativeBadges} = payload;
        return {
            ...state,
            superlativeBadges
        };
    },
    [listingExtendedActions.FETCH_DISCOVERY_SUCCESS](
        state,
        {
            payload: {discoveryFeed}
        }
    ) {
        return {
            ...state,
            discoveryFeed
        };
    },
    [listingExtendedActions.FETCH_UNIT_SPACES_SUCCESS](state, {payload}) {
        const {unitSpaces} = payload;
        return {
            ...state,
            unitSpaces
        };
    },
    [listingExtendedActions.FETCH_HOUSE_RULES_SUCCESS](state, {payload}) {
        const {houseRules} = payload;
        return {
            ...state,
            houseRules
        };
    },
    [listingExtendedActions.FETCH_RECOMMENDED_PROPERTIES](state) {
        return {
            ...state,
            recommendedPropertiesIsFetching: true
        };
    },
    [listingExtendedActions.FETCH_RECOMMENDED_PROPERTIES_SUCCESS](state, {payload}) {
        const {recommendedProperties} = payload;
        return {
            ...state,
            recommendedProperties,
            recommendedPropertiesIsFetching: false,
            recommendedPropertiesFetchSuccess: true
        };
    },
    [listingExtendedActions.FETCH_RECOMMENDED_PROPERTIES_FAILED](state) {
        return {
            ...state,
            recommendedPropertiesIsFetching: false,
            recommendedPropertiesFetchFailed: true
        };
    },
    [listingExtendedActions.FETCH_BY_OWNER_PROPERTIES_SUCCESS](state, {payload}) {
        const {byOwnerProperties} = payload;
        return {
            ...state,
            byOwnerProperties,
            byOwnerPropertiesFetchSuccess: true
        };
    },
    [listingExtendedActions.FETCH_BY_OWNER_PROPERTIES_FAILED](state) {
        return {
            ...state,
            byOwnerPropertiesFetchFailed: true
        };
    },
    [listingExtendedActions.FETCH_INQUIRY_PROPERTIES_SUCCESS](state, {payload}) {
        const {inquiryProperties} = payload;
        return {
            ...state,
            inquiryProperties,
            inquiryPropertiesFetchSuccess: true
        };
    },
    [listingExtendedActions.FETCH_INQUIRY_PROPERTIES_FAILED](state) {
        return {
            ...state,
            inquiryPropertiesFetchFailed: true
        };
    },
    [listingExtendedActions.FETCH_REGISTRATION_NUMBER_SUCCESS](state, {payload}) {
        const {registrationNumber} = payload;
        return {
            ...state,
            registrationNumber
        };
    },
    [listingExtendedActions.FETCH_GEO_DISTANCE_SUCCEES](state, {payload}) {
        const {geoRelativeDistances} = payload;
        return {
            ...state,
            geoRelativeDistances
        };
    },
    [listingActions.TRANSLATE_PROPERTY_DESCRIPTION_SUCCESS](state, {payload}) {
        const {localizedDescription} = payload;
        return {
            ...state,
            description: localizedDescription
        };
    },
    [listingActions.SAVE_PROPERTY_DESCRIPTION](state, {payload = {}}) {
        const {descriptionToSave, locale} = payload;
        const {localizedPropertyDescriptionMap} = state;

        const newTranslatedPropertyDescriptionMap = Object.assign(
            {},
            localizedPropertyDescriptionMap
        );
        newTranslatedPropertyDescriptionMap[locale] = descriptionToSave;
        return {
            ...state,
            localizedPropertyDescriptionMap: newTranslatedPropertyDescriptionMap
        };
    },
    [listingExtendedActions.FETCH_THINGS_OF_INTEREST_SUCCESS](state, {payload}) {
        const {thingsOfInterest} = payload;
        return {
            ...state,
            thingsOfInterest
        };
    },
    [vtHelpfulnessActions.UPDATE_VT_HELPFULNESS_HISTORY](state, {payload}) {
        const {vtHelpfulnessHistory} = payload;
        return {
            ...state,
            vtHelpfulnessHistory
        };
    }
};

export default createReducer(actionHandlers, initialState);
